import { render, staticRenderFns } from "./JobDescriptionStepModule.vue?vue&type=template&id=5083257a&scoped=true"
import script from "./JobDescriptionStepModule.vue?vue&type=script&lang=js"
export * from "./JobDescriptionStepModule.vue?vue&type=script&lang=js"
import style0 from "./JobDescriptionStepModule.vue?vue&type=style&index=0&id=5083257a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083257a",
  null
  
)

export default component.exports